import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { appPaths } from "../../../shared/routing/appPaths";
import { WorkspaceLink } from "../../../shell/workspace";
import { termName, type TermCards } from "../../ontology/terms/termNames";

/**
 * A term a statement uses, by its label in the data model at the version the data was written
 * against (F94), from that version's `cards` in the statement's own project (Sol review R3); it
 * opens the term on the Data model beside, at that version (F75). Without that version the name
 * stays plain text. `children`, where given, are the words a text links with instead of the name.
 */
export default function TermLink({ iri, commit, cards, children }: { iri: string; commit: string | null; cards: TermCards | null; children?: ReactNode }) {
  const { i18n } = useTranslation();
  const name = children ?? termName(iri, cards, i18n.resolvedLanguage ?? "en");
  if (commit === null) return <span title={iri}>{name}</span>;
  return (
    <WorkspaceLink route={appPaths.ontology({ version: commit, termIri: iri })} placement="beside" className="app-link" title={iri}>
      {name}
    </WorkspaceLink>
  );
}
